import { render, staticRenderFns } from "./UserApproval.vue?vue&type=template&id=6d484d20&scoped=true&"
import script from "./UserApproval.vue?vue&type=script&lang=js&"
export * from "./UserApproval.vue?vue&type=script&lang=js&"
import style0 from "./UserApproval.vue?vue&type=style&index=0&id=6d484d20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d484d20",
  null
  
)

export default component.exports